<template>
  <section>
    <qx-card :title="title" class="detail" v-loading="loading">
      <qx-detail-box
        v-for="(data, index) in detailData"
        :data="data"
        :key="index"
      />
      <div class="editPage">
        <qx-card-form title="登记信息">
          <qx-custom-form
            :noSubBtn="true"
            ref="baseForm"
            :formData="baseForm"
            labelWidth="140px"
          >
            <section slot="backUserName" slot-scope="prop">
              <ChooseStaff
                :isRadio="true"
                v-model="prop.form.backUserName"
                @change="handleDriverChange"
              />
            </section>
          </qx-custom-form>
        </qx-card-form>
        <SubBtnBox @sub="sub" />
      </div>
    </qx-card>
  </section>
</template>
<script>
import {
  getVehicleCertificatesInsurance, // 获取详情
  doEndInsurance, // 终止
} from 'api/car';
import SubBtnBox from 'components/subBtnBox';
import pageDataMixin from '@qx/mixin/pageData';
import ChooseStaff from 'components/choose/staff';
export default {
  components: {
    SubBtnBox,
    ChooseStaff,
  },
  mixins: [
    pageDataMixin,
  ],
  data () {
    return {
      title: '终止车辆保险登记',
      loading: false,
      detailData: {
        base: {
          label: '基础信息',
          tableData: {
            title: [
              {
                prop: 'plateNumber',
                label: '车牌号码',
              },
              {
                prop: 'licenceTypeName',
                label: '车辆类型',
              },
              {
                prop: 'orgName',
                label: '归属部门',
              },
              {
                prop: 'vehicleLoad',
                label: '准牵引总质量（吨）',
              },
              {
                prop: 'brandModel',
                label: '品牌',
              },
              {
                prop: 'axleNumber',
                label: '轴数',
              },
              {
                prop: 'volume',
                label: '车辆容积',
              },
              {
                prop: 'vehicleInfo',
                label: '车型类型',
              },
            ],
            data: {},
            approveData: {},
          },
        },
        info: {
          label: '保险信息',
          tableData: {
            title: [
              {
                prop: 'licenceTypeName',
                label: '保险类型',
              },
              {
                prop: 'certificatesInsuranceFee',
                label: '保费（元）',
              },
              {
                prop: 'insuranceStartDate',
                label: '生效日期',
              },
              {
                prop: 'insuranceEndDate',
                label: '失效日期',
              },
              {
                prop: 'insuranceCompany',
                label: '保险公司',
              },
              {
                prop: 'insuranceCode',
                label: '保单号',
              },
              {
                prop: 'agentCompany',
                label: '被保险人',
              },
              // {
              //   prop: 'picList',
              //   label: '证件图片',
              // },
            ],
            data: {},
            approveData: {},
          },
        },
      },
      baseForm: {
        form: [
          { label: '退保费', value: 'backInsuranceFee', type: 'input' },
          { label: '退保日期', value: 'insuranceTerminationDate', type: 'date', attr: { time: '00:00:00' } },
          { label: '经办人', value: 'backUserName', default: {}, type: 'input', slot: true },
          { label: '经办人电话', value: 'backUserTel', type: 'input', disabled: true },
          { label: '退保原因', value: 'backInsuranceDetail', type: 'input', attr: { type: 'textarea', limit: 300 } },
        ],
        rules: {
          insuranceTerminationDate: [
            { required: true, message: '请选择退保日期', trigger: 'blur' },
          ],
        },
      },
      formComponents: [
        'baseForm',
      ],
    };
  },
  watch: {
    '$route.query.id': function () {
      // 监听id来刷新页面，因为会出现多个查看详情的tab，用的都是同一个页面，所以需要监听id来回请求获取当前id的数据
      this.getData();
    },
  },
  methods: {
    async getData () {
      // 遇到这两个URL就阻止页面刷新
      if (this.$route.path !== '/manage/car/maintain/insurance/stop') {
        return;
      }
      this.loading = true;
      const detailRes = await getVehicleCertificatesInsurance({
        id: this.$route.query.id,
      });
      this.loading = false;
      if (!detailRes.failed) {
        // 处理数据
        this.detailData.base.tableData.data = detailRes.vehicle;
        this.detailData.info.tableData.data = detailRes;
        this.detailData.info.tableData.data.licenceTypeName = detailRes.vehicle.licenceTypeName;
      }
    },
    handleDriverChange () {
      const backUserName = this.$refs.baseForm.getVal('backUserName');
      this.$refs.baseForm.setVal('backUserTel', backUserName.loginAcct);
    },
    async sub () {
      const formData = await this.$refs.baseForm.sub();
      if (formData) {
        let params = {
          ...formData,
          id: this.$route.query.id,
        };
        if (params.backUserName.userId) {
          params.backUserId = params.backUserName.userId;
          params.backUserName = params.backUserName.linkman;
          params.backUserTel = params.backUserName.loginAcct;
        }
        if (params.insuranceTerminationDate) {
          params.insuranceTerminationDate = this.formatDate(params.insuranceTerminationDate);
        }
        delete params.backUserName;
        const detailRes = await doEndInsurance(params);
        if (!detailRes.failed) {
          this.$message({
            type: 'success',
            message: '操作成功',
          });
          this.close();
        }
      }
    },
  },
  mounted () {
    this.getData();
  },
};
</script>
<style>
</style>
